import { SocialMediaPostFields } from "../../types/request.types";
import { capitalize } from "inflection";
import { formatDate } from "../../lib/date-time-formatters";

import classes from "./Request.module.css";
import { Group } from "@mantine/core";
import PlatformBadge from "../badges/PlatformBadge";

interface SocialMediaPostProps {
  request: SocialMediaPostFields;
}

const SocialMediaPost = ({ request }: SocialMediaPostProps) => (
  <dl className={classes.details}>
    <dt>Project name</dt>
    <dd>{request.name}</dd>
    <dt>Description</dt>
    <dd dangerouslySetInnerHTML={{__html: request.description || ''}}></dd>
    <dt>Links/Calls to action</dt>
    <dd dangerouslySetInnerHTML={{__html: request.links || ''}}></dd>
    <dt>Promotion Type</dt>
    <dd>{capitalize(request.promotion_type)}</dd>
    <dt>Budget Code</dt>
    <dd>{request.budget_code}</dd>
    <dt>Platforms</dt>
    <dd>
      <Group gap="sm" mt="xs">
        {request.platforms.map(p => <PlatformBadge key={p} platform={p} />)}
      </Group>
    </dd>
    <dt>Requested completion date</dt>
    <dd>
      {request.requested_completion_date && formatDate(request.requested_completion_date)}
    </dd>
  </dl>
);

export default SocialMediaPost;